<template>
    <div class="RecordDecode">
        <div class="title" v-text="tip"></div>
        <div class="list">
          <div class="item" v-for="(item, index) in listData" :key="index">
            <div class="top">
              <div class="subTitle">
                <span class="label" v-text="item.label"></span>
                <span v-text="item.record"></span>
              </div>
              <van-rate v-model="item.starValue" readonly />
            </div>
            <div class="bottom" v-text="item.desc"></div>
          </div>
        </div>
    </div>
</template>

<script>
import { Rate } from 'vant'
export default {
  name: 'Type',
  data () {
    return {
      tip: '行为分是平台针对用户违规行为所制定的一个评分标准。当用户出现违规行为时，管理员会根据违规类型对用户的行为分进行扣减。行为分划定了3个层级，每个层级受到的处罚严重程度不同',
      listData: [
        {
          label: '初始分数',
          record: '12分',
          starValue: 5,
          desc: '每位用户的初始行为分为12分，根据违规情况进行扣减。'
        },
        {
          label: '警惕分数',
          record: '6分',
          starValue: 3,
          desc: '当行为分扣减为6分或更低，每出现一次违规，平台将限制用户购买15天。'
        },
        {
          label: '危险分数',
          record: '0分',
          starValue: 0,
          desc: '当行为分扣减为0分，账号将永久封禁。'
        }
      ]
    }
  },
  components: {
    'van-rate': Rate
  }
}
</script>

<style lang="scss" scoped>
.RecordDecode {
  .list {
    .item {
      margin-bottom: 20px;
      .top {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        height: 30px;
        .subTitle {
          display: flex;
          align-items: center;
          font-weight: 700;
          margin-right: 20px;
          width: 120px;
          font-size: 15px;
          line-height: 15px;
          .label {
            margin-right: 10px;
          }
        }
      }
      .bottom {
        color: #abacac;
        line-height: 22px;
      }
    }
  }
}
</style>
